// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { MessageFrontend as createMessageFrontendStatuspageNavigationSpotlight } from '@post-office/message-template--statuspage-navigation-spotlight/placements/in-app-v2/statuspage-navigation-spotlight-placement';

import { PlacementFrontend } from '@post-office/placements--statuspage/statuspage-navigation-spotlight-placement';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/placement-common-v2/create-placement/types';

import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendStatuspageNavigationSpotlight({
		messageTemplateId: 'statuspage-navigation-spotlight',
	}),
];

export const RawPlacement: PlacementRendererStage<Record<string, never>> = PlacementFrontend.createPlacementFrontendComponent({
	messageTemplates: messageFrontends,
});

export const Placement: ComponentType<Omit<Record<string, never>, "ref"> & {
    ref?: unknown;
}> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<Record<string, never>> = RawPlacement;
